import { render, staticRenderFns } from "./bold-line.vue?vue&type=template&id=23d5454b&scoped=true&"
import script from "./bold-line.vue?vue&type=script&lang=js&"
export * from "./bold-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d5454b",
  null
  
)

export default component.exports